module.exports = __webpack_public_path__ + "static/media/aftercallwork.f59bce24.svg";